import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "staff" && isShowOnAboutPage == true && !(_id in path('drafts.**'))] {
    slug,
    _id,
    name,
    image
  }`;
}
